/* import { StrictMode } from 'react' */
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App';
import { CustomSnackProvider } from "@sicarx/sxw-components"
import { configI18n, isElectron } from "@sicarx/sxw-core"; configI18n();
import { WithAxios } from '@sicarx/sxw-api';
import { SxRouter } from './components/SxRouter';
import { setSicarxProperties } from './utils/helpers';

import initSentry from "./sentry"

initSentry()

if (isElectron()) {

  window.electron.getBaseURL().then(baseURL => {
    setSicarxProperties({ baseURL })
  })

  import('i18next').then(async ({ default: m }) => {
    await window.electron.changeLanguage(m.language)
  })

} else {
  setSicarxProperties({ baseURL: window.location.origin })
}


/* initSentry() */
createRoot(document.getElementById('root')!).render(
  <CustomSnackProvider>
    <SxRouter basename='/'>
      <WithAxios>
        <App />
      </WithAxios>
    </SxRouter>
  </CustomSnackProvider>
)
